<template>
  <div id="ordershow" v-if="isImagefinish">
    <div class="list-title" @click="showOrderList = !showOrderList">
      <h2 :class="[showOrderList ? activeToggle : noToggle]">您的購物車</h2>
      <span>TWD {{sum}}</span>
    </div>
    <div class="order-list-wrap" v-bind:class="{'noshow':showOrderList}">
      <div class="order-list" v-for="(item,index) in cartOrder" :key="index">
        <div class="item-img" @click="lightboxControl(index)">
          <img v-bind:src="item.imageUrl" alt="item" />
          <p>點擊看大圖</p>
          <div class="zoomin"></div>
        </div>
        <div class="item-name">
          <span>{{item.shape}}-{{item.style}}</span>
          <span>{{item.size.length}}{{item.size.unit}}{{item.size.weight}}錢{{item.size.way}}</span>
          <span>( 配件選擇：{{accessoryDisplay(item.accessory)}} )</span>
        </div>
        <div class="item-amount">
          <span class="item-amount-title">數量：</span>
          <span>{{item.amount}}</span>
          <span>個</span>
        </div>
        <div class="item-price">
          <span class="item-price-title">金額：</span>
          <span>TWD {{item.total}}</span>
        </div>
        <!-- <div class="item-accessory">
          <span>其他配件：</span>
          <span>{{accessoryDisplay(item.accessory)}}</span>
        </div> -->
      </div>
      <div class="calculate">
        <div class="calculate-total-title">
          <span>小計</span>
        </div>
        <div class="calculate-total">
          <span>TWD {{subtotal}}</span>
        </div>
        <div class="calculate-delivery-title">
          <span>運費</span>
        </div>
        <div class="calculate-delivery">
          <span>{{freight}}</span>
        </div>
      </div>
      <div class="total-payment-wrap">
        <div>
          <span>總額</span>
          <span v-if="this.$store.getters.getSpecialMemberState !== 1">(包含營業稅)</span>
        </div>
        <div class="total-payment">
          <span>TWD {{sum}}</span>
        </div>
      </div>
      <div class="edit-cart">
        <router-link to="/gold/cart/cart_order">
          <button>編輯購物車</button>
        </router-link>
      </div>
    </div>
    <div class="lightbox" v-bind:class="{'displaynone':closeLightbox}" v-body-scroll-lock="!closeLightbox">
      <div class="center-container">
        <img v-bind:src="lightboxImg" />
        <div href="#" class="lightbox-close" @click="closeLightbox=!closeLightbox">
          <img src="@/images/icon-close@2x-white.png" />
        </div>
      </div>
    </div>
  </div>
  <div class="load" v-else>
    <div class="line"></div>
    <div class="line"></div>
    <div class="line"></div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";
export default {
  name: "CartOrdershow",
  created() {
    this.getAccessoryList();
    this.cartOrder = this.getCartOrder();
    this.cartOrder.forEach(item => {
      axios({
        url: `${item.imageUrl}`,
        method: "get"
      })
        .then(response => {
          item.imageUrl = response.data;
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    });
    this.cartOrder.forEach(item => {
      item.size.way = this.$store.getters.getTransformWay(item.size.way);
      item.size.unit = this.$store.getters.getTransformUnit(item.size.unit);
    });
    this.calcSubtotal();
    this.getFreight();
  },
  data() {
    return {
      isImagefinish: false,
      showOrderList: true,
      cartOrder: "",
      subtotal: 0,
      freight: "",
      lightboxImg: "",
      closeLightbox: true,
      activeToggle: "arrow-down",
      noToggle: "arrow-up",
      sum: "",
      accessoryList: []
    };
  },
  watch: {
    cartOrder: {
      handler() {
        if (typeof this.cartOrder !== "undefined") {
          let checkNum = 0;
          this.cartOrder.forEach(item => {
            if (item.imageUrl.substring(0, 4) == "data") {
              checkNum = checkNum + 1;
            }
          });
          if (checkNum == this.cartOrder.length) {
            this.isImagefinish = true;
          }
        }
      },
      deep: true
    }
  },
  methods: {
    getCartOrder() {
      return JSON.parse(localStorage.getItem("cartorder"));
    },
    async getAccessoryList() {
      try {
        let res = await this.$store.dispatch("getAccessoryList");
        this.accessoryList = res.data;
      } catch (e) {
        console.log(e);
      }
    },
    calcSubtotal() {
      this.cartOrder.forEach(item => {
        this.subtotal = parseInt(this.subtotal) + parseInt(item.total);
      });
    },
    lightboxControl(index) {
      this.closeLightbox = !this.closeLightbox;
      this.lightboxImg = this.cartOrder[index].imageUrl;
    },
    getFreight() {
      axios({
        url: this.$store.getters.getGlobalUrl + "freight",
        method: "get",
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(response => {
          this.freight = response.data.data.freight;
          this.sum = parseInt(this.freight) + parseInt(this.subtotal);
        })
        .catch(e => {
          alert(`錯誤訊息：${e.response.data.message}，請重新檢查`);
        });
    }
  },
  computed: {
    calcSum() {
      return parseInt(this.$store.getters.getFreight) + parseInt(this.subtotal);
    },
    accessoryDisplay() {
      return function(accessoryId) {
        if (this.accessoryList.length === 0) {
          return 0;
        }
        let filterResult = this.accessoryList.filter(
          accessory => accessory.id == accessoryId
        );
        return `${filterResult[0].name} - TWD ${filterResult[0].price}`;
      };
    }
  }
};
</script>

<style scoped lang="scss">
#ordershow {
  width: 52%;
  box-sizing: border-box;
  background-color: #fff;
  max-width: 600px;
  text-align: left;
  padding: 48px 50px;
  @include table {
    width: 100%;
    max-width: 768px;
    box-sizing: border-box;
    padding: 25px 16px;
    padding-bottom: 0px;
  }
  .list-title {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid $primaryDeepColor;
    @include table {
      cursor: pointer;
    }
    h2 {
      color: $secondaryDeepColor1;
      font-size: 24px;
      line-height: 31px;
      padding-bottom: 8px;
      margin: 0;
      display: inline-block;
    }
    span {
      font-size: 24px;
      font-weight: 800;
      display: none;
      @include table {
        display: inline-block;
      }
    }
  }
}

.arrow-down {
  position: relative;
}

.arrow-down::after {
  display: inline-block;
  content: " ";
  height: 8px;
  width: 8px;
  border-width: 0 2px 2px 0;
  border-color: $secondaryDeepColor1;
  border-style: solid;
  transform: rotate(45deg);
  transition: transform 0.1s;
  position: absolute;
  top: 7px;
  left: 135px;
  visibility: hidden;
  @include table {
    visibility: visible;
  }
}

.arrow-up {
  position: relative;
}

.arrow-up::after {
  display: inline-block;
  content: " ";
  height: 8px;
  width: 8px;
  border-width: 0 2px 2px 0;
  border-color: $secondaryDeepColor1;
  border-style: solid;
  transform: rotate(225deg);
  transition: transform 0.1s;
  position: absolute;
  top: 11px;
  left: 135px;
  visibility: hidden;
  @include table {
    visibility: visible;
  }
}

.order-list {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr;
  grid-template-rows: 1fr auto;
  align-items: center;
  color: $secondaryDeepColor1;
  border-bottom: 1px solid $primaryDeepColor;
  font-size: 15px;
  justify-content: space-between;
  padding: 16px;
  @include table {
    padding: 0;
    grid-template-columns: 1fr;
  }

  .item-img {
    grid-column: 1 / span 3;
    @include table {
      grid-column: 1;
    }

    img {
      width: 40px;
      height: auto;
      vertical-align: middle;
      padding: 16px 16px 16px 0;
      @include table {
        padding: 16px;
      }
    }
    p {
      display: inline-block;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .zoomin {
    width: 12px;
    height: 12px;
    display: inline-block;
    background-image: url("../../images/biger@2x.png");
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    margin-left: 3px;
    &:hover {
      cursor: pointer;
    }
  }
  .item-name {
    padding-bottom: 16px;
    span {
      display: block;
    }
  }
  .item-amount {
    text-align: center;
    @include table {
      text-align: left;
      padding-bottom: 8px;
    }
    .item-amount-title {
      display: none;
      @include table {
        display: inline-block;
      }
    }
    span:nth-child(3) {
      @include table {
        display: none;
      }
    }
  }
  .item-price {
    text-align: right;
    @include table {
      text-align: left;
      padding-bottom: 8px;
    }
    .item-price-title {
      display: none;
      @include table {
        display: inline-block;
      }
    }
  }
  .item-accessory {
    grid-column-start: 1;
    grid-column-end: 4;
    @include table {
      grid-column-start: 1;
      grid-column-end: 1;
    }
  }
}

.calculate {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto;
  color: $secondaryDeepColor1;
  font-size: 15px;
  padding: 16px;
  @include table {
    padding: 0;
  }
  .calculate-total-title {
    span {
      display: block;
      padding-top: 16px;
    }
  }
  .calculate-delivery-title {
    span {
      display: block;
      padding-top: 16px;
      padding-bottom: 32px;
    }
  }
  .calculate-total {
    text-align: right;
    span {
      display: block;
      padding-top: 16px;
    }
  }
  .calculate-delivery {
    text-align: right;
    span {
      display: block;
      padding-top: 16px;
      padding-bottom: 32px;
    }
  }
}
.total-payment-wrap {
  display: grid;
  grid-template-columns: 1fr 1fr;
  color: $secondaryDeepColor1;
  padding-bottom: 16px;
  padding-left: 16px;
  @include table {
    padding-left: 0;
  }

  span {
    display: block;
    font-weight: 800;
  }
  .total-payment {
    font-size: 24px;
    text-align: right;
  }
}

.edit-cart {
  text-align: center;
  button {
    width: 198px;
    height: 36px;
    border: 1px solid #979797;
    background-color: transparent;
    font-size: 17px;
    color: $secondaryDeepColor1;
  }
}
.noshow {
  @include table {
    display: none;
  }
}
.lightbox {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1111111;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  .center-container {
    flex: 0 0 80vmin;
    background-color: $secondaryColor3;
    @include phone {
      flex: 0 0 90vmin;
    }
  }
  img {
    width: 100%;
    height: auto;
    max-height: 80vh;
    object-fit: contain;
  }
  .lightbox-close {
    box-sizing: border-box;
    max-width: 45px;
    max-height: 45px;
    padding: 8px;
    background: $primaryDeepColor;
    color: #fff;
    position: absolute;
    top: 0;
    right: 0;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.displaynone {
  display: none;
}
//loading
.load {
  padding-top: 160px;
  text-align: center !important;
}
.load .line:nth-last-child(1) {
  animation: loadingC 0.6s 0.1s linear infinite;
}
.load .line:nth-last-child(2) {
  animation: loadingC 0.6s 0.2s linear infinite;
}
.load .line:nth-last-child(3) {
  animation: loadingC 0.6s 0.3s linear infinite;
}
.line {
  display: inline-block;
  width: 15px;
  height: 15px;
  margin: 3px;
  border-radius: 15px;
  background-color: #a8894c;
}
@keyframes loadingC {
  0% {
    transform: translate(0, 0);
  }
  50% {
    transform: translate(0, 15px);
  }
  100% {
    transform: translate(0, 0);
  }
}
</style>
